export default __webpack_public_path__ + "static/media/circle_light_hover.c0afce35.svg";